export const getInventorySourcingList = state => {
    return state.list
}

export const getInventorySourcingDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/inventorySourcing/getters.js